export default __webpack_public_path__ + "static/media/mightyape.5adf25c8.png";